import { connect } from 'react-redux';
import EnhancementButton from '../enhancementButton/enhancementButton';
import { closePanelByType, openPanel } from '../../../../shared/actions/sidebar';
import { panelGroup, panelType } from '../../../../shared/constants';
import { isPanelOpen, shouldRestoreOpenerFocus } from '../../../../shared/actions/sidebarUtils';

const mapStateToProps = (state) => {
  const {
    figures: {
      data = [],
    },
    sidebar,
  } = state;

  return {
    active: sidebar.isOpen && isPanelOpen(state, panelGroup.enhancements, panelType.figures),
    canShow: data.length > 0,
    heading: `Figures (${data.length})`,
    attributeId: 'figures',
    restoreFocus: shouldRestoreOpenerFocus(state, panelGroup.enhancements, panelType.figures),
  };
};

const mapDispatchToProps = dispatch => ({
  closeSidePanel: () => dispatch(closePanelByType(panelGroup.enhancements, panelType.figures)),
  openSidePanel: () => dispatch(openPanel(panelGroup.enhancements, panelType.figures)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EnhancementButton);
